/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

export default class ConfigurationAgentIndexRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    this.router.replaceWith('apps.app.ask', this.appService.app.id, {
      queryParams: transition.to?.queryParams ?? {},
    });
  }
}
